import { useLazyLoadQuery } from 'react-relay';
import { UserActionLastActionQuery } from '../graphQLOperations/__generated__/UserActionLastActionQuery.graphql';
import { getLastUserAction } from '../graphQLOperations/UserAction';

export const useHasTeacherSkippedOrCompletedIntro = (userId?: string): boolean => {
  const data = useLazyLoadQuery<UserActionLastActionQuery>(
    getLastUserAction,
    {
      id: `UserNode:${userId ?? ''}`,
      action: ['ActionTypeNode:15', 'ActionTypeNode:16'],
    },
    { fetchPolicy: 'network-only' },
  );

  if (!userId) return false;
  return (data.allUserActions?.nodes?.length ?? 0) > 0;
};
